
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBeaconGeneralSphere as ObiBeaconGeneralSphereElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-beacon-general-sphere.js';
 
 
 

 
 export const ObiBeaconGeneralSphere = createComponent({
   react: React,
   tagName: 'obi-beacon-general-sphere',
   elementClass: ObiBeaconGeneralSphereElement,
   events: {
     
   }
  });
 
 